import { render } from "./ProductDeleteModal.vue?vue&type=template&id=66945be6&scoped=true&ts=true"
import script from "./ProductDeleteModal.vue?vue&type=script&lang=ts"
export * from "./ProductDeleteModal.vue?vue&type=script&lang=ts"

import "./ProductDeleteModal.vue?vue&type=style&index=0&id=66945be6&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66945be6"]])

export default __exports__